<template>
  <social-sharing :url="url"
                  :title="title"
                  :description="description"
                  :quote="title"
                  :hashtags="hashTags"
                  twitter-user="binar_code"
                  inline-template>
    <div class="flex flex-row justify-between cursor-pointer">
      <network class="mx-1 md:mx-2 social-icon" network="facebook">
        <facebook-icon/>
      </network>
      <network class="mx-1 md:mx-2 social-icon" network="twitter">
        <twitter-icon/>
      </network>
      <network class="mx-1 md:mx-2 social-icon" network="linkedin">
        <linkedin-icon/>
      </network>
    </div>
  </social-sharing>
</template>
<script>
  import Vue from 'vue'
  import { LinkedinIcon, TwitterIcon, FacebookIcon } from 'vue-feather-icons'

  Vue.component('facebook-icon', FacebookIcon)
  Vue.component('twitter-icon', TwitterIcon)
  Vue.component('linkedin-icon', LinkedinIcon)
  export default {
    name: 'social-share-icons',
    props: {
      title: {
        type: String,
      },
      description: {
        type: String,
      },
      hashTags: {
        type: String,
      },
      quote: {
        type: String,
      }
    },
    data() {
      return {
        url: ''
      }
    },
    mounted() {
      this.url = window.location.href
    }
  }
</script>
<style lang="scss">
  .social-icon {
    svg {
      &:hover {
        fill: var(--color-primary)
      }
    }
  }
</style>
